

import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import ClientsidePaging from "./ClientsidePaging";

@Component({})

export default class ClientsidePagingSelector extends Vue {
    @Prop({ required: true })
    paging!: ClientsidePaging;

    @Prop({ required: true })
    totalRows!: number;

    @Prop({ default: false })
    belowTable!: boolean;

    onPageSizeChange = () => {
        this.paging.pageNumber = 1;
    }
}

